<div class="form-layout-compact">
  @if (lmWebAppComponent) {
    <div class="displayOnInfo font-size-sm">{{'DisplayTargets' | translate}}</div>
    <soho-listview
      selectable='true'
      disableItemDeactivation="'true'">
      @for (targetInfo of lmWebAppComponent.target; track targetInfo; let i = $index) {
        <li soho-listview-item  class="lm-flex-column-nowrap">
          <div class="lm-flex-row-two-table-container">
            <div attr.data-automation-id="lm-menu-security-info-displayType-{{i}}" class="displayOnInfo font-size-sm">{{targetInfo.displayType}}</div>
            <div attr.data-automation-id="lm-menu-security-info-displayVersion-{{i}}" class="displayOnInfo font-size-sm">{{targetInfo.displayVersion}}</div>
          </div>
          @if (targetInfo.showCondition) {
            <div attr.data-automation-id="lm-menu-security-info-showCondition-{{i}}" class="displayOnInfo font-size-xs">{{'ValidWhen' | translate}} {{targetInfo.showCondition}}</div>
          }
        </li>
      }
    </soho-listview>
  }
  @if (lmWebAppComponentItem) {
    <div class="row field">
      <label soho-label for="lm-menu-security-info-property-id">{{'PropertyId' | translate}}</label>
      <input soho-input data-automation-id="lm-menu-security-info-property-id"
        name="lm-menu-security-info-property-id"
        id="lm-menu-security-info-property-id"
        [readOnly]="true"
        [(ngModel)]="lmWebAppComponentItem.propertyId">
      </div>
      <div class="row field">
        <label soho-label for="lm-menu-security-info-target-link">{{ 'MenuLink' | translate }}</label>
        <input soho-input data-automation-id="lm-menu-security-info-target-link"
          name="lm-menu-security-info-target-link"
          id="lm-menu-security-info-target-link"
          [readOnly]="true"
          [(ngModel)]="lmWebAppComponentItem.target.link">
        </div>
        @if (lmWebAppComponentItem.searchTerms?.length > 0) {
          <label soho-label data-automation-id="lm-menu-security-info-search-term-label">{{'SearchTerms' | translate}}</label>
          @for (term of lmWebAppComponentItem.searchTerms; track term; let i = $index) {
            <li class="font-size-sm" attr.data-automation-id="lm-menu-security-info-search-term-{{i}}">{{term}}</li>
          }
        }
      }
    </div>

    <!-- COMPONENT -->

    <!-- ITEM -->
